import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import usePageTitle from '../hooks/usePageTitle';

const InvestorAlertPage = () => {
  usePageTitle('Investor Alert');
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Header />
      <main id="main-content" tabIndex={-1} className="pt-32 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-gray-500 hover:text-[#C8473A] mb-8 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" aria-hidden="true" />
            Back to Home
          </Link>

          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12 text-[#211F1F]">
            <p className="text-sm text-gray-500 uppercase tracking-wider mb-2">
              YourNest Capital Advisors
            </p>
            <h1 className="text-3xl md:text-4xl font-bold text-[#211F1F] mb-10 border-b border-gray-200 pb-6">
              INVESTOR ALERT: UNAUTHORISED USE OF NAME &ldquo;YOURNEST CAPITAL ADVISORS&rdquo;
            </h1>

            <div className="prose prose-gray max-w-none text-[15px] leading-relaxed space-y-6">
              <p>
                This is to inform the public that certain fraudulent websites, mobile applications, and communications are misusing the name &ldquo;YourNest Capital Advisors&rdquo;, and falsely claiming to offer investment opportunities, including promises of &ldquo;assured&rdquo; or &ldquo;guaranteed&rdquo; returns.
              </p>

              <p>YourNest Capital Advisors hereby clarifies:</p>

              <h2 className="text-xl font-bold text-[#211F1F] mt-10 mb-3">1. No Retail Solicitation</h2>
              <p>
                YourNest Capital Advisors does not solicit or accept investments from the general public through online platforms, apps, or individual investment accounts.
              </p>

              <h2 className="text-xl font-bold text-[#211F1F] mt-10 mb-3">2. No Assured/Guaranteed Returns</h2>
              <p>
                YourNest Capital Advisors does not offer or promise assured/guaranteed returns in any form.
              </p>

              <h2 className="text-xl font-bold text-[#211F1F] mt-10 mb-3">3. Authorised Channels Only</h2>
              <p>
                Our only official website is: <a href="https://yournest.in/" target="_blank" rel="noopener noreferrer" className="text-[#C8473A] hover:underline font-medium">https://yournest.in/</a>
              </p>
              <p>
                We do not operate or authorise any other domains (including, but not limited to, &ldquo;yournestcapital.com&rdquo;).
              </p>

              <h2 className="text-xl font-bold text-[#211F1F] mt-10 mb-3">4. No Unofficial Communication</h2>
              <p>
                We do not solicit investments via WhatsApp, Telegram, SMS, social media, or any unofficial communication channels.
              </p>

              <h2 className="text-xl font-bold text-[#211F1F] mt-10 mb-3">5. Impersonation is Fraudulent</h2>
              <p>
                Any person/entity/platform claiming association with YourNest Capital Advisors outside the above channels is unauthorised and fraudulent.
              </p>

              <h2 className="text-xl font-bold text-[#211F1F] mt-10 mb-3">Investor Advisory</h2>
              <p>
                Members of the public are advised to exercise caution and verify all investment opportunities independently. Please do not rely on unsolicited offers, especially those promising fixed/guaranteed returns.
              </p>
              <p>If you have been approached or have transacted with such fraudulent entities, you should:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Immediately stop further transactions;</li>
                <li>Contact your bank to report suspected fraud;</li>
                <li>Report the matter on India&apos;s National Cyber Crime Reporting Portal (<a href="https://cybercrime.gov.in/" target="_blank" rel="noopener noreferrer" className="text-[#C8473A] hover:underline">cybercrime.gov.in</a>) or call 1930; and</li>
                <li>Retain all supporting records (payment proofs, communications, screenshots) and mail these to <a href="mailto:investor.relations@yournest.in" className="text-[#C8473A] hover:underline">investor.relations@yournest.in</a> for our information.</li>
              </ul>

              <h2 className="text-xl font-bold text-[#211F1F] mt-10 mb-3">Disclaimer</h2>
              <p>
                YourNest Capital Advisors shall not be liable for any loss or damage incurred by any person arising from dealings with unauthorised entities misrepresenting our name or brand.
              </p>
              <p>
                We are taking appropriate steps, including reporting such instances to regulatory and law enforcement authorities.
              </p>
              <p>
                For official information, please refer only to our website: <a href="https://yournest.in/" target="_blank" rel="noopener noreferrer" className="text-[#C8473A] hover:underline font-medium">https://yournest.in</a>
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default InvestorAlertPage;
